<template>
  <div class="col-span-2">
    <GoogleSignInButton
      class="w-full cursor-pointer text-[10px] sm:text-base flex items-center justify-center gap-4 py-4 px-14 border-2 border-gray-300 bg-white rounded-2xl"
      @success="onGoogleSuccess"
      @error="onGoogleError"
      :buttonConfig="{
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        shape: 'pill',
        logo_alignment: 'left',
      }"
    />
  </div>
</template>

<script>
import axios from "axios";
import { GoogleSignInButton } from "vue3-google-signin";
import { server } from "../../../config/global";

const BASE_URL = server.API_URL;

export default {
  name: "LoginWithGoogle",
  components: { GoogleSignInButton },

  data() {
    return {
      codeInfluencer: this.$route.query.invitation,
    };
  },

  methods: {
    // Decodifica el ID Token (JWT) para extraer email, sub, name, picture, etc.
    parseJwt(token) {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(decodeURIComponent(escape(atob(base64))));
    },

    async onGoogleSuccess(resp) {
      try {
        // GIS entrega el ID Token en resp.credential
        const idToken = resp.credential;
        const claims = this.parseJwt(idToken); // { sub, email, name, picture, ... }

        // Envío al backend — hoy tu endpoint espera estos campos
        const response = await axios.post(`${BASE_URL}client/login-gmail`, {
          email: claims.email,
          gmail_id: claims.sub,
          name: claims.name,
          profile_image_url: claims.picture,
          store_id: 2, // <- conserva tu store_id original
          influencer_code: this.codeInfluencer,
          // Opcional: también mándales el id_token por si más adelante validan en server
          id_token: idToken,
        });

        if (response.status === 200) {
          const b = response.data.body;
          const prof = b.attributes.profile.attributes;
          const userable = prof.userable.attributes;

          // Dirección
          if (b.attributes.addresses.length) {
            const a = b.attributes.addresses[0].attributes;
            const direction = {
              nombre: a.address,
              lat: a.lat,
              lng: a.lng,
              departamento: a.department,
              provincia: a.city,
              distrito: a.district,
              location: a.free,
            };
            localStorage.setItem("direction", JSON.stringify(direction));
          }

          // Usuario (igual que tu flujo actual)
          const dataUser = {
            globalID: b.id,
            globalName: prof.name,
            globalLastName: prof.surnames,
            globalImage: userable.profile_image_url,
            globalValidate: b.attributes.validation.verified,
            glovalEmail: userable.email,
            identificador: b.client_code,
            type: 2,
          };
          localStorage.setItem("auth", JSON.stringify(dataUser));

          if (!prof.cellphone) localStorage.setItem("completecellphone", "true");

          // Redirección/recarga igual que antes
          if (this.$route.query.redirect) {
            this.$router.push(String(this.$route.query.redirect));
            localStorage.removeItem("open");
          } else {
            location.reload();
            localStorage.removeItem("open");
          }
        }
      } catch (error) {
        console.error("Error al iniciar sesión con Google:", error);
        this.$store.state.alert.titulo = "Error";
        this.$store.state.alert.description =
          error?.response?.data?.message || "Error al iniciar sesión con Google";
        this.$store.state.alert.estado = true;
      }
    },

    onGoogleError(err) {
      console.error("Google Sign-In error:", err);
      this.$store.state.alert.titulo = "Error";
      this.$store.state.alert.description =
        "No se pudo completar el inicio de sesión con Google";
      this.$store.state.alert.estado = true;
    },
  },
};
</script>
